import {
  GlobalEvents,
  SnippetElement,
  defineElement,
  onClick,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/snippets/common-sort-component/common-sort-component.ts
var CommonSortComponent = class extends SnippetElement {
  toggle() {
    return __async(this, null, function* () {
      var _a;
      (_a = this.sortPopover) == null ? void 0 : _a.toggle();
    });
  }
  open() {
    return __async(this, null, function* () {
      var _a;
      (_a = this.sortPopover) == null ? void 0 : _a.open();
    });
  }
  close() {
    return __async(this, null, function* () {
      var _a;
      (_a = this.sortPopover) == null ? void 0 : _a.close();
    });
  }
  get sortParams() {
    const active = this.sortValues.find((e) => e.hasAttribute("active"));
    if (!active)
      return new URLSearchParams();
    const sortBy = active.getAttribute("data-sort-value");
    const urlParams = new URLSearchParams();
    urlParams.set("sort_by", sortBy);
    return urlParams;
  }
  clickFilterOption(element) {
    return __async(this, null, function* () {
      this.sortValues.forEach((element2) => {
        element2.removeAttribute("active");
      });
      element.setAttribute("active", "");
      this.close();
      GlobalEvents.emit("filter:changeMobile");
    });
  }
  connectedCallback() {
    document.addEventListener("click", (event) => {
      var _a;
      if (!((_a = this.sortPopover) == null ? void 0 : _a.contains(event.target)) && !this.sortButton.contains(event.target)) {
        this.close();
      }
    });
  }
  disconnectedCallback() {
    this.remove();
  }
};
__decorateClass([
  query("[data-sort-popover]")
], CommonSortComponent.prototype, "sortPopover", 2);
__decorateClass([
  query("[data-sort-button]")
], CommonSortComponent.prototype, "sortButton", 2);
__decorateClass([
  queryAll("[data-sort-value]")
], CommonSortComponent.prototype, "sortValues", 2);
__decorateClass([
  onClick("[data-sort-button]")
], CommonSortComponent.prototype, "toggle", 1);
__decorateClass([
  onClick("[data-sort-value]")
], CommonSortComponent.prototype, "clickFilterOption", 1);
CommonSortComponent = __decorateClass([
  defineElement("common-sort-component")
], CommonSortComponent);
export {
  CommonSortComponent
};
